import React from "react";
import { Link } from "react-router-dom";
import GenreFavoritesContainer from "~/Containers/GenreFavoritesContainer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as faStarOutline } from "@fortawesome/free-regular-svg-icons";
import styled from "styled-components";

export const WrapperNoFav = styled.section`
  margin-top: 20px;
  margin-bottom: 20px;
`;
export const Wrapper = styled.section`
  line-height: 18px;
  margin: 0 10px 5px 0;
`;
const ProfileFavoriteGenres = ({ dir, isOwner }) => (
  <GenreFavoritesContainer
    dir={dir}
    render={({ genres }) => {
      if (genres.length === 0 && !isOwner) return null;
      return (
        <div className="profile-right-nav profile-most-recent-purchase">
          <h3>Favorite Genres</h3>
          {genres.length === 0 && isOwner ? (
            <WrapperNoFav>
              You haven't added any favorites yet.
              <br />
              <br />
              Tip: Click the {` `}
              <FontAwesomeIcon icon={faStarOutline} /> {` `}
              on any genre page to add as a favorite. For example: "<Link to={`/genre/610`}>Baked Electronics</Link>"
            </WrapperNoFav>
          ) : (
            <div>
              {genres.map((genre) => (
                <Wrapper>
                  <Link to={`/genre/${genre.id}`}>{genre.name}</Link>
                </Wrapper>
              ))}
            </div>
          )}
        </div>
      );
    }}
  ></GenreFavoritesContainer>
);

export default ProfileFavoriteGenres;
